/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_MASQUERADER_LIST = gql`
  query GetUserAdvancedSearch($filter: UserAdvancedSearchFilterInput, $options: GetManyOptions) {
    getUserAdvancedSearch(filter: $filter, options: $options) {
      content {
        _id
        presentation {
          name
          status
        }
        ReferalUsers {
          fullName
          email
          gender
          address {
            addressLine1
            addressLine2
            city
            country
            state
            zipcode
          }
        }
        Section {
          name
          _id
        }
        CostumeType {
          name
          _id
        }
        Referal {
          inviteType
          partition
        }
        id
        User {
          email
          fullName
          _id
          gender
          address {
            addressLine1
            addressLine2
            city
            country
            state
            zipcode
          }
        }
        paymentStats
        createdAt
        boxStatus
        costumeID
        isActive
        isVIP
        section
        totalAmount
        updatedAt
      }
      count
      limit
      skip
    }
  }
`;
